// This file is loaded on all pages of runningCoach.
// It is used to load global styles and scripts.

import 'jquery';

window.$ = window.jQuery = require('jquery');